/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { HIDE_SUCCESS_MESSAGE } from 'actions/successMessage';
import {
  UPDATE_PROFILE_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_SUCCESS,
  ADD_PICTURE_SUCCESS,
} from 'actions/user';
import { UPDATE_COMPANY_SUCCESS } from 'actions/company';
import {
  UPDATE_JOB_SUCCESS,
  PUBLISH_JOB_SUCCESS,
  UNPUBLISH_JOB_SUCCESS,
  CREATE_JOB_SUCCESS,
  UPDATE_POSITION_SUCCESS,
  DELETE_POSITION_SUCCESS,
  ADD_POSITION_SUCCESS,
  UPDATE_MOODBOARD_SUCCESS,
} from 'actions/job';

import p from 'polyglot/polyglot';

const initialState = {
  show: false,
  scrollToTop: true,
  message: '',
};

/**
 * This is the company reducer. It listens for actions and updates the company object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type }) {
  switch (type) {
    case UPDATE_COMPANY_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case UPDATE_JOB_SUCCESS:
    case CREATE_JOB_SUCCESS:
    case UPDATE_POSITION_SUCCESS:
    case DELETE_POSITION_SUCCESS:
    case ADD_POSITION_SUCCESS:
    case UPDATE_MOODBOARD_SUCCESS:
      return {
        show: true,
        scrollToTop: true,
        message: p.t('general.update_message'),
      };

    case PUBLISH_JOB_SUCCESS:
      return {
        show: true,
        scrollToTop: true,
        message: p.t('jobs.messages.job_published'),
      };

    case UNPUBLISH_JOB_SUCCESS:
      return {
        show: true,
        scrollToTop: true,
        message: p.t('jobs.messages.job_unpublished'),
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        show: true,
        scrollToTop: true,
        message: p.t('send_reset.code_sent'),
      };

    case UPDATE_PASSWORD_SUCCESS:
      return {
        show: true,
        scrollToTop: true,
        message: p.t('new_password.password_updated'),
      };

    case ADD_PICTURE_SUCCESS:
      return {
        show: true,
        scrollToTop: false,
        message: p.t('portfolio.messages.image_uploaded'),
      };

    case HIDE_SUCCESS_MESSAGE:
      return initialState;

    default:
      return state;
  }
}
